import React from 'react';

export default function Popup({ title, children, onClose }) {
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.65)', zIndex:200, display:'flex', alignItems:'center', justifyContent:'center' }}
      onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ background:'var(--surface)', border:'1px solid var(--border2)', borderRadius:8, padding:24, minWidth:420, maxWidth:580, maxHeight:'80vh', overflowY:'auto' }}>
        <div style={{ fontFamily:'var(--serif)', fontSize:16, fontWeight:400, marginBottom:16, display:'flex', justifyContent:'space-between', alignItems:'center' }}>
          <span>{title}</span>
          <span onClick={onClose} style={{ cursor:'pointer', color:'var(--muted)', fontSize:18, lineHeight:1 }}>✕</span>
        </div>
        {children}
      </div>
    </div>
  );
}
